import { render, staticRenderFns } from "./button-open-modal.vue?vue&type=template&id=4fb63a54"
import script from "./button-open-modal.vue?vue&type=script&lang=js"
export * from "./button-open-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports